import { createSelector } from '@ngrx/store';
import { accountRegisterSelector } from './account-register.reducer';

export const selectAccountRegisterIncludeInactive = createSelector(accountRegisterSelector, (state) => {
   return state.includeInactive;
});

export const selectFilters = createSelector(accountRegisterSelector, (state) => {
   return state.filters;
});
